<div *ngFor="let subgroup of group?.subgroups" class="my-3">
  <app-group-view [group]="subgroup"></app-group-view>
</div>
